import React, { useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars-4";
import { useSnackbar } from "notistack";
import {
  CircularProgress,
  Backdrop,
  Container,
  Paper,
  Typography,
  Toolbar,
  Tooltip,
  Stack,
  IconButton,
  List,
  Grid,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { useNavigate } from "react-router-dom";
import { getSchema } from "../helpers/schemas/getSchema";
import FeatureFields from "../Feature/FeatureFields";
import { useLocation } from "react-router-dom";
import { Add } from "@mui/icons-material";
import { applyEditTrackingFields } from "../helpers/applyEditTrackingFields";
import EditDialog from "../Dialogs/EditDialog";
import { checkInvalidField } from "../helpers/checkInvalidField";
import { getFormInvalid } from "../helpers/getFormInvalid";
import { onEditDeleteAll } from "../helpers/onEditDeleteAll";
import { saveToFirestore } from "../helpers/saveToFirestore";
import { castDateFields } from "../helpers/castDateFields";
import { castDateToFireStoreDate } from "../helpers/castDateToFireStoreDate";
import { firestoreAutoId } from "../helpers/firestoreAutoId";
import { getSortArray } from "../helpers/getSortArray";
import SortDialog from "../Dialogs/SortDialog";
import setupEdit from "../helpers/setupEdit";
import ContactCard from "./ContactCard";
import { getProject } from "../helpers/getProject";
import PieChartView from "./PieChartView";
import { getIssuesData } from "./getIssuesData";
import { getEquipData } from "./getEquipData";
import { getChecklistData } from "./getChecklistData";
import { getChecklistRowsData } from "./getChecklistRowsData";
import { getObservationData } from "./getObservationData";
import { getFileData } from "./getFileData";
import DonutChartView from "./DonutChartView";
import ClosingPanel from "./ClosingPanel";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useTheme } from "@mui/material/styles";
import DefectAreaChart from "./DefectAreaChart";
import ActiveEquipment from "./ActiveEquipment";
import { getUserAccess } from "../helpers/getUserAccess";

function ProjectDashboard({ user, saveCurrentProject }) {
  // const theme = useTheme();
  // const isSmallScreenUp = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location.state);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(true);
  const [isReady, setIsReady] = React.useState(false);
  const [project, setProject] = React.useState({});
  const [schema, setSchema] = React.useState([]);
  const [editFeature, setEditFeature] = React.useState(null);
  const [editSchema, setEditSchema] = React.useState([]);
  const [allContacts, setAllContacts] = React.useState([]);
  const [contacts, setContacts] = React.useState([]);
  const [formErrorMessage, setformErrorMessage] = React.useState("");
  const [editDialogOpen, setEditDialogOpen] = React.useState(false);
  const [filterValue, setFilterValue] = React.useState("");
  const [sortByValue, setSortByValue] = React.useState("Name");
  const [sortByOptions] = React.useState([
    "Name",
    "Name Desc",
    "Email",
    "Email Desc",
    "Phone",
    "Phone Desc",
  ]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [tab, setTab] = React.useState(0);
  const [defectData, setDefectData] = React.useState([]);
  const [activeEquipmentData, setActiveEquipmentData] = React.useState([]);

  const onSortChange = (value, array) => {
    if (value !== sortByValue) {
      setSortByValue(value);
    }
    const obs = getSortArray(value, array);
    setContacts([...obs]);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = window.location.href.split("/");

        const projectId = params[params.length - 2];
        const proj = await getProject(projectId);
        const projSch = getSchema("projects");
        setSchema(projSch);
        setProject(proj);
        saveCurrentProject(proj);
        onSortChange(sortByValue, proj.Contacts);
        setAllContacts(proj.Contacts);

        var equip = [];
        proj.Equipment.forEach((e) => {
          var isses = proj.Issues.filter(
            (issue) =>
              issue.equipment_id === e.id &&
              (issue.Status === "Open" || issue.Status === "In Progress"),
          );
          equip.push({ ...e, activeIssues: isses.length });
        });
        setActiveEquipmentData(
          equip.sort((a, b) => b.activeIssues - a.activeIssues).slice(0, 3),
        );

        const newData = getIssuesData(
          proj.Issues.filter((issue) => issue["Assigned To"] === "Designers"),
        );
        setDefectData([...newData]);
      } catch (error) {
        console.error("Error getting document:", error);
        enqueueSnackbar(error.message, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };
    if (isLoading === true && isReady === false) {
      setIsReady(true);
      fetchData();
    }
  });

  const editProject = (id) => {
    console.log(id);
    navigate(
      `/Feature?id=${project.id}&formdisabled=false&tablename=projects&fk_id=none`,
      { state: { passProject: project } },
    );
  };

  const onAddContactClick = () => {
    var item = {};
    var schema = getSchema("contact");
    schema.forEach((fd) => {
      item[fd.name] = "";
    });

    item["id"] = "new";

    item = applyEditTrackingFields(item, user);

    setEditSchema(schema);
    setEditFeature(item);
    setEditDialogOpen(true);
  };

  const onEditChange = (e) => {
    try {
      // console.log(e);
      var att = editSchema.find((item) => item.name === e.target.name);
      const formErrorMessage = checkInvalidField(e.target.value, att);
      if (att.type === "date") {
        if (e.target.value.length > 0) {
          var date = new Date(e.target.value);
          // date.setDate(date.getDate() + 1);
          editFeature[e.target.name] = date.toISOString().split("T")[0];
          // editFeature[e.target.name] = date.getTime();
          setEditFeature({ ...editFeature });
          setformErrorMessage(formErrorMessage);
        }
      } else if (att.type === "bit") {
        editFeature[e.target.name] = e.target.checked;
        setEditFeature({ ...editFeature });
        setformErrorMessage(formErrorMessage);
      } else {
        editFeature[e.target.name] = e.target.value;
        setEditFeature({ ...editFeature });
        setformErrorMessage(formErrorMessage);
      }
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
    }
  };

  const onEditSave = async () => {
    try {
      //check for invalid
      var feat = { ...editFeature };
      feat.Selected = false;
      var invalidResults = getFormInvalid(feat, editSchema);
      if (invalidResults.isInvalid === true) {
        setEditFeature({ ...invalidResults.feature });
        setEditSchema([...invalidResults.schema]);
        setformErrorMessage(invalidResults.formErrorMessage);
        return;
      }

      setIsLoading(true);

      const newFeat = castDateFields(feat, editSchema);
      const newEditFeature = castDateToFireStoreDate({ ...newFeat });
      var contactsToSave = [];
      if (newEditFeature.id === "new") {
        newEditFeature.id = firestoreAutoId();
        allContacts.push(newEditFeature);
        setAllContacts([...allContacts]);
        contactsToSave = allContacts;
        contacts.push(newEditFeature);
        onSortChange(sortByValue, contacts);
      } else {
        const updatedArray1 = allContacts.map((obj) => {
          if (obj.id === newEditFeature.id) {
            return newEditFeature; // Replace the object if its ID matches
          }
          return obj; // Keep other objects as they are
        });
        setAllContacts([...updatedArray1]);        
        contactsToSave = updatedArray1;
        var updatedOldEmail = "";
        const updatedArray2 = contacts.map((obj) => {
          if (obj.id === newEditFeature.id) {
            //check if old email needs removed
            if (
              newEditFeature.hasOwnProperty("Email") &&
              obj.Email !== newEditFeature.Email &&
              obj.Email.length > 0
            ) {
              updatedOldEmail = obj.Email;
            }
            return newEditFeature; // Replace the object if its ID matches
          }
          return obj; // Keep other objects as they are
        });
        onSortChange(sortByValue, updatedArray2);
      }
      const updatedProject = { ...project };
      updatedProject.Contacts = [...contactsToSave];
      if (
        newEditFeature.hasOwnProperty("Email") &&
        updatedProject.allowed_emails.includes(newEditFeature.Email) === false
      ) {
        updatedProject.allowed_emails.push(newEditFeature.Email);
        if (updatedOldEmail.length > 0) {
          updatedProject.allowed_emails = [
            ...updatedProject.allowed_emails.filter(
              (email) => email !== updatedOldEmail,
            ),
          ];
        }
      }
      setProject(updatedProject);
      //Finally save the project
      await saveToFirestore("projects", updatedProject);
      setEditDialogOpen(false);
      enqueueSnackbar("Contact saved successfully", {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "success",
      });
      setIsLoading(false);
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
      setIsLoading(false);
    }
  };

  const onEditCancel = () => {
    setformErrorMessage("");
    setEditDialogOpen(false);
  };

  const onEditDelete = async () => {
    try {
      setIsLoading(true);
      if (
        project.hasOwnProperty("Email") &&
        project.allowed_emails.includes(editFeature.Email)
      ) {
        project.allowed_emails = [
          ...project.allowed_emails.filter(
            (email) => email !== editFeature.Email,
          ),
        ];
      }
      const savedProj = await onEditDeleteAll(
        project,
        editFeature,
        [],
        "Contacts",
        "contacts_id",
        user,
      );
      setProject({ ...savedProj });
      // setAllThecontacts(savedProj.contacts);
      enqueueSnackbar("Contact deleted successfully", {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "success",
      });
      setEditDialogOpen(false);
      setIsLoading(false);
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
      setIsLoading(false);
    }
  };

  const onEmailContactClick = (recipient) => {
    // Define the email parameters
    const subject =
      "You're invited to collaborate with our BECx GO Project: " + project.Name;

    const body = `Good ${
      new Date().getHours() > 12
        ? new Date().getHours() > 17
          ? "evening"
          : "afternoon"
        : "morning"
    },\n\nYou're invited to collaborate with our BECx GO Project: ${
      project.Name
    }.\n\nPlease login (or sign up with email address: ${recipient}) and click the following link for project information:\n${
      window.location.href
    }\n\n\nThanks,\n${user.displayName}`;

    // Encode the subject and body to handle spaces and special characters correctly
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);

    // Construct the mailto URI
    const mailtoUri = `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`;

    // Use window.location.href to open the user's default email client
    window.location.href = mailtoUri;
  };

  const onEdit = (id) => {
    var item = allContacts.find((obj) => obj.id === id);
    const results = setupEdit({ ...item }, "contact");
    setIsLoading(false);
    setEditSchema(results.schema);
    setEditFeature({ ...results.item });
    setEditDialogOpen(true);
  };

  const onFilterChange = (searchTerm) => {
    if (searchTerm.length > 2) {
      const filteredData = allContacts.filter((obj) => {
        const values = Object.values(obj);
        return values.some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase()),
        );
      });
      setContacts([...filteredData]);
    } else {
      setContacts([...allContacts]);
    }
    setFilterValue(searchTerm);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    // console.log(newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleTabChange = (e, newValue) => {
    setTab(newValue);

    if (newValue === 0) {
      const newData = getIssuesData(
        project.Issues.filter((issue) => issue["Assigned To"] === "Designers"),
      );
      setDefectData([...newData]);
    } else {
      const newData = getIssuesData(
        project.Issues.filter(
          (issue) => issue["Assigned To"] === "Contractors",
        ),
      );
      setDefectData([...newData]);
    }
  };

  return isLoading ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <Scrollbars
      autoHide
      autoHideTimeout={10}
      style={{ width: "100%", height: "100%" }}
    >
      <Toolbar />
      <Container
        maxWidth={false}
        style={{
          // paddingTop: 30,
          paddingBottom: 30,
          // paddingBottom: theme.spacing(4),
          justifyContent: "center",
        }}
      >
        <Typography
          color="primary.light"
          style={{ paddingTop: 30 }}
          variant="h5"
          gutterBottom
        >
          Project Dashboard
        </Typography>

        <Paper elevation={6} style={{ marginTop: 20, width: "100%" }}>
          <Grid style={{ padding: 15 }} container spacing={2}>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Typography
                color="primary.light"
                style={{ paddingLeft: 10, paddingTop: 3, paddingBottom: 0 }}
              >
                {`Design Issues: ${
                  project.Issues.filter(
                    (issue) => issue["Assigned To"] === "Designers",
                  ).length
                }`}
              </Typography>
              <PieChartView
                data={getIssuesData(
                  project.Issues.filter(
                    (issue) => issue["Assigned To"] === "Designers",
                  ),
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Typography
                color="primary.light"
                style={{ paddingLeft: 10, paddingTop: 3, paddingBottom: 0 }}
              >
                {`Construction Issues: ${
                  project.Issues.filter(
                    (issue) => issue["Assigned To"] === "Contractors",
                  ).length
                }`}
              </Typography>
              <PieChartView
                data={getIssuesData(
                  project.Issues.filter(
                    (issue) => issue["Assigned To"] === "Contractors",
                  ),
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Typography
                color="primary.light"
                style={{ paddingLeft: 10, paddingTop: 3, paddingBottom: 0 }}
              >
                {`Equipment Issues: ${
                  project.Issues.filter(
                    (issue) => issue["Assigned To"] === "Designers",
                  ).length
                }`}
              </Typography>
              <PieChartView
                data={getIssuesData(
                  project.Issues.filter(
                    (issue) =>
                      issue.hasOwnProperty("equipment_id") &&
                      issue.equipment_id.length > 0,
                  ),
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Typography
                color="primary.light"
                style={{ paddingLeft: 10, paddingTop: 3, paddingBottom: 0 }}
              >
                {`Equipment: ${project.Equipment.length}`}
              </Typography>
              <PieChartView data={getEquipData(project.Equipment)} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Typography
                color="primary.light"
                style={{ paddingLeft: 10, paddingTop: 3, paddingBottom: 0 }}
              >
                {`Observations: ${project.Observations.length}`}
              </Typography>
              <PieChartView data={getObservationData(project.Observations)} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Typography
                color="primary.light"
                style={{ paddingLeft: 10, paddingTop: 3, paddingBottom: 0 }}
              >
                {`Checklists: ${project.Checklists.length}`}
              </Typography>
              <PieChartView data={getChecklistData(project.Checklists)} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Typography
                color="primary.light"
                style={{ paddingLeft: 10, paddingTop: 3, paddingBottom: 0 }}
              >
                {`Checklist Rows: ${
                  project.Issues.filter(
                    (issue) => issue["Assigned To"] === "Contractors",
                  ).length
                }`}
              </Typography>
              <PieChartView data={getChecklistRowsData(project.Checklists)} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Typography
                color="primary.light"
                style={{ paddingLeft: 10, paddingTop: 3, paddingBottom: 0 }}
              >
                {`Files: ${
                  project.Issues.filter(
                    (issue) => issue["Assigned To"] === "Contractors",
                  ).length
                }`}
              </Typography>
              <PieChartView
                data={getFileData(project.Files, project.Checklists)}
              />
            </Grid>
          </Grid>
        </Paper>

        <Paper elevation={6} style={{ marginTop: 20 }}>
          <div style={{ padding: 16 }}>
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={tab}
                  onChange={handleTabChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Design Issues" />
                  <Tab label="Construction Issues" />
                </Tabs>
              </Box>

              {defectData.length > 0 && tab === 0 && (
                <Grid container spacing={2}>
                  <Grid size={{ sm: 4, md: 2 }}>
                    {defectData.filter((f) => f.value > 0).length > 0 && (
                      <DonutChartView
                        count={
                          defectData.find((f) => f.name.includes("Open")).value
                        }
                        total={defectData.reduce((a, v) => {
                          return a + v.value;
                        }, 0)}
                        title="Open"
                        color={
                          defectData.find((f) => f.name.includes("Open")).color
                        }
                      />
                    )}
                  </Grid>
                  <Grid size={{ sm: 4, md: 2 }}>
                    {defectData.filter((f) => f.value > 0).length > 0 && (
                      <DonutChartView
                        count={
                          defectData.find((f) => f.name.includes("In Progress"))
                            .value
                        }
                        total={defectData.reduce((a, v) => {
                          return a + v.value;
                        }, 0)}
                        title="In Progress"
                        color={
                          defectData.find((f) => f.name.includes("In Progress"))
                            .color
                        }
                      />
                    )}
                  </Grid>
                  <Grid size={{ sm: 4, md: 2 }}>
                    {defectData.filter((f) => f.value > 0).length > 0 && (
                      <DonutChartView
                        count={
                          defectData.find((f) => f.name.includes("Pending"))
                            .value
                        }
                        total={defectData.reduce((a, v) => {
                          return a + v.value;
                        }, 0)}
                        title="Pending"
                        color={
                          defectData.find((f) => f.name.includes("Pending"))
                            .color
                        }
                      />
                    )}
                  </Grid>
                  <Grid size={{ sm: 4, md: 2 }}>
                    {defectData.filter((f) => f.value > 0).length > 0 && (
                      <DonutChartView
                        count={
                          defectData.find((f) => f.name.includes("Closed"))
                            .value
                        }
                        total={defectData.reduce((a, v) => {
                          return a + v.value;
                        }, 0)}
                        title="Closed"
                        color={
                          defectData.find((f) => f.name.includes("Closed"))
                            .color
                        }
                      />
                    )}
                  </Grid>
                  <Grid
                    style={{ paddingTop: 10 }}
                    size={{ sm: 12, md: 2 }}
                    sx={{
                      display: {
                        xs: "none", // Hidden on small screens (600px and up)
                        sm: "none", // Hidden on small screens (600px and up)
                        md: "block", // Hidden on medium screens (900px and up)
                      },
                    }}
                  >
                    <ClosingPanel
                      title="a"
                      closeDate={project["Target Closing Date"]}
                    />
                  </Grid>
                  <Grid
                    style={{ paddingTop: 10 }}
                    size={{ sm: 12, md: 2 }}
                    sx={{
                      display: {
                        xs: "none", // Hidden on small screens (600px and up)
                        sm: "none", // Hidden on small screens (600px and up)
                        md: "block", // Hidden on medium screens (900px and up)
                      },
                    }}
                  >
                    <ActiveEquipment
                      activeEquipmentData={activeEquipmentData}
                      projectId={project.id}
                    />
                  </Grid>
                </Grid>
              )}
              {defectData.length > 0 && tab === 1 && (
                <Grid container spacing={0}>
                  <Grid size={{ sm: 4, md: 2 }}>
                    {defectData.filter((f) => f.value > 0).length > 0 && (
                      <DonutChartView
                        count={
                          defectData.find((f) => f.name.includes("Open")).value
                        }
                        total={defectData.reduce((a, v) => {
                          return a + v.value;
                        }, 0)}
                        title="Open"
                        color={
                          defectData.find((f) => f.name.includes("Open")).color
                        }
                      />
                    )}
                  </Grid>
                  <Grid size={{ sm: 4, md: 2 }}>
                    {defectData.filter((f) => f.value > 0).length > 0 && (
                      <DonutChartView
                        count={
                          defectData.find((f) => f.name.includes("In Progress"))
                            .value
                        }
                        total={defectData.reduce((a, v) => {
                          return a + v.value;
                        }, 0)}
                        title="In Progress"
                        color={
                          defectData.find((f) => f.name.includes("In Progress"))
                            .color
                        }
                      />
                    )}
                  </Grid>
                  <Grid size={{ sm: 4, md: 2 }}>
                    {defectData.filter((f) => f.value > 0).length > 0 && (
                      <DonutChartView
                        count={
                          defectData.find((f) => f.name.includes("Pending"))
                            .value
                        }
                        total={defectData.reduce((a, v) => {
                          return a + v.value;
                        }, 0)}
                        title="Pending"
                        color={
                          defectData.find((f) => f.name.includes("Pending"))
                            .color
                        }
                      />
                    )}
                  </Grid>
                  <Grid size={{ sm: 4, md: 2 }}>
                    {defectData.filter((f) => f.value > 0).length > 0 && (
                      <DonutChartView
                        count={
                          defectData.find((f) => f.name.includes("Closed"))
                            .value
                        }
                        total={defectData.reduce((a, v) => {
                          return a + v.value;
                        }, 0)}
                        title="Closed"
                        color={
                          defectData.find((f) => f.name.includes("Closed"))
                            .color
                        }
                      />
                    )}
                  </Grid>
                  <Grid
                    style={{ paddingTop: 10 }}
                    size={{ sm: 12, md: 2 }}
                    sx={{
                      display: {
                        xs: "none", // Hidden on small screens (600px and up)
                        sm: "none", // Hidden on small screens (600px and up)
                        md: "block", // Hidden on medium screens (900px and up)
                      },
                    }}
                  >
                    <ClosingPanel
                      title="b"
                      closeDate={project["Target Closing Date"]}
                    />
                  </Grid>
                  <Grid
                    style={{ paddingTop: 10 }}
                    size={{ sm: 12, md: 2 }}
                    sx={{
                      display: {
                        xs: "none", // Hidden on small screens (600px and up)
                        sm: "none", // Hidden on small screens (600px and up)
                        md: "block", // Hidden on medium screens (900px and up)
                      },
                    }}
                  >
                    <ActiveEquipment
                      activeEquipmentData={activeEquipmentData}
                      projectId={project.id}
                    />
                  </Grid>
                </Grid>
              )}

              <Grid container spacing={0}>
                <Grid size={{ sm: 12, md: 8 }}>
                  {defectData.length > 0 && (
                    <DefectAreaChart
                      issues_log={project.issues_log}
                      issues={project.Issues}
                      assigned={tab === 0 ? "Designers" : "Contractors"}
                    />
                  )}
                </Grid>
                <Grid
                  style={{ paddingTop: 10 }}
                  size={{ sm: 12, md: 12 }}
                  sx={{
                    display: {
                      sm: "block", // Hidden on small screens (600px and up)
                      md: "none", // Hidden on medium screens (900px and up)
                    },
                  }}
                >
                  <ClosingPanel
                    title="c"
                    closeDate={project["Target Closing Date"]}
                  />
                </Grid>
                <Grid
                  style={{ paddingTop: 10 }}
                  size={{ xs: 12, sm: 12, md: 12 }}
                  sx={{
                    display: {
                      xs: "block", // Hidden on small screens (600px and up)
                      sm: "block", // Hidden on small screens (600px and up)
                      md: "none", // Hidden on medium screens (900px and up)
                    },
                  }}
                >
                  <ActiveEquipment
                    activeEquipmentData={activeEquipmentData}
                    projectId={project.id}
                  />
                </Grid>
              </Grid>
            </Box>
          </div>
        </Paper>

        <Paper elevation={6} style={{ marginTop: 20 }}>
          <Typography
            color="primary.light"
            style={{ paddingTop: 8, paddingLeft: 16 }}
            variant="h5"
            // gutterBottom
          >
            Project Details
          </Typography>
          <div style={{ padding: 16 }}>
            <FeatureFields
              allowUpdate={
                getUserAccess(user, project.uid, project.Contacts).allowUpdate
              }
              TableName={"Project"}
              onEditClick={editProject}
              feature={project}
              schema={schema}
              key={0}
            />
          </div>
        </Paper>

        <Typography
          color="primary.light"
          style={{ paddingTop: 40 }}
          variant="h5"
          gutterBottom
        >
          Project Contacts
        </Typography>

        <Stack
          style={{ paddingRight: 22 }}
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <Tooltip title={`Add Contact`}>
            <IconButton
              onClick={onAddContactClick}
              disabled={
                !getUserAccess(user, project.uid, project.Contacts).allowCreate
              }
              aria-label={`Add Contact`}
              size="large"
              color="primary"
            >
              <Add fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </Stack>
        <Stack
          style={{ paddingTop: 30 }}
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {allContacts.length > 0 && (
            <SortDialog
              sortByValue={sortByValue}
              onSortChange={onSortChange}
              objArray={contacts}
              sortByOptions={sortByOptions}
              filterValue={filterValue}
              onFilterChange={onFilterChange}
              page={page}
              handleChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          )}

          {contacts.length === 0 && filterValue === "" ? (
            <Typography>
              There aren't any contacts associated with your project. Please add
              <IconButton
                onClick={onAddContactClick}
                aria-label="Add Contact"
                size="medium"
                color="primary"
              >
                <AddBoxIcon fontSize="inherit" />
              </IconButton>
              a new contact.
            </Typography>
          ) : contacts.length === 0 && filterValue.length > 2 ? (
            <Typography>
              There aren't any contacts associated with your search: "
              <strong>{filterValue}</strong>"
            </Typography>
          ) : (
            <List style={{ width: "100%" }}>
              <ContactCard
                contacts={contacts}
                projectId={project.id}
                page={page}
                rowsPerPage={rowsPerPage}
                onEdit={onEdit}
                onEmailContactClick={onEmailContactClick}
                allowUpdate={
                  getUserAccess(user, project.uid, project.Contacts).allowUpdate
                }
                // onDetailsClick={onDetailsClick}
                // handleChecked={handleChecked}
              />
            </List>
          )}
        </Stack>
        <EditDialog
          allowDeleteAccess={
            getUserAccess(user, project.uid, project.Contacts).allowDelete
          }
          feature={editFeature}
          editFiles={[]}
          importTitle={"New Project Contact"}
          getAcceptedFiles={null}
          onEditFileCommentChange={null}
          onRemoveEditFile={null}
          schema={editSchema}
          onChange={onEditChange}
          onEditSave={onEditSave}
          onEditDelete={onEditDelete}
          isOpen={editDialogOpen}
          onClose={onEditCancel}
          formErrorMessage={formErrorMessage}
          allowDelete={true}
          allowFiles={false}
        />
      </Container>
    </Scrollbars>
  );
}

export default ProjectDashboard;
